module.exports = __webpack_public_path__ + "media/images/lb/333-ecfa88449adbf1b5be6dc2f0b247b126.svg";